import { Box, Divider, Link, Stack, Typography } from '@mui/material';
import { supportEmail } from 'appConfig';
import React from 'react';

export default function AssistanceFooter({ type }: { type?: string }) {
    return (
        <Box sx={{ mt: 5 }}>
            <Typography sx={{ my: 1 }} variant="body1">
                {type || 'Need Assistance?'}{' '}
            </Typography>
            <Divider />
            <Stack direction={{ xs: 'column', md: 'row' }} mb={2} justifyContent="space-between">
                <Typography sx={{ fontSize: { xs: 10, lg: 14 }, marginTop: 2 }} variant="body1">
                    Customer service m-f 8:00AM -5:00PM EST
                </Typography>
                <Typography sx={{ fontSize: { xs: 10, lg: 14 }, marginTop: 2 }} variant="body1">
                    1-800-099-9999
                </Typography>
                <Typography sx={{ fontSize: { xs: 10, lg: 14 }, marginTop: 2 }} variant="body1">
                    <Link
                        href="#"
                        color="inherit"
                        onClick={(e) => {
                            window.location.href = `mailto:${supportEmail}`;
                            e.preventDefault();
                        }}
                    >
                        {supportEmail}
                    </Link>
                </Typography>
            </Stack>
        </Box>
    );
}
